<template>
  <p class="chatgpt-proof" :class="{ dark: onDark, center: centered }" data-chatgpt-proof>
    {{ tr('Workspace369 is now an approved plugin in ChatGPT.') }}
    <NuxtLink
      :to="localePath(chatgptProofPath)"
      data-conversion-event="chatgpt_proof_click"
      data-conversion-label="ChatGPT proof"
      :data-conversion-location="location"
    >{{ tr('Read the announcement') }}</NuxtLink>
  </p>
</template>

<script setup>
// One proof line under a trial button, on the sales pages only.
import { chatgptProofPath } from '~/data/chatgpt-listing';

defineProps({
  location: { type: String, default: '' },
  onDark: { type: Boolean, default: false },
  centered: { type: Boolean, default: false },
});

const { tr } = useHomeI18n();
const { localePath } = useWorkspaceLocale();
</script>

<style scoped>
.chatgpt-proof {
  margin: 0.55rem 0 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: #475569;
}
.chatgpt-proof.center { text-align: center; }
.chatgpt-proof.dark { color: rgba(226, 232, 240, 0.92); }
.chatgpt-proof a { color: inherit; text-decoration: underline; text-underline-offset: 2px; }
:global(.dark .chatgpt-proof:not(.dark)) { color: #cbd5e1; }
</style>
